const StatusTypeEnum = Object.freeze({
    ACTIVE : 'active',
    INACTIVE: 'inactive'
})

export default StatusTypeEnum;